import React from 'react';

export const LayoutList: React.FC<{children: React.ReactNode}> = ({ children }) => {
  return <div className="flex w-full md:max-w-96 max-h-80 md:max-h-full">{children}</div>;
};
